import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
  <span class="navheader-text"><slot></slot></span>
`

class NavHeaderText extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() { }
}

customElements.define('ts-navheader-text', NavHeaderText)
